import { useEffect, useState } from 'react';

import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuABEA';

import header from '../../images/abea-header.png'

import constantes from '../../helpers/constanteHelper';

function Sobre() {
    const [width, setWidth] = useState(window.innerWidth);


    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.ROXO_ABEA }} className='text-center d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'sobre'} />
                <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center'>
                    <div style={{ height: resolucaoMobile ? '20px' : '80px' }}></div>

                    <Image style={{ height: '600px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
                    <h1 className={resolucaoMobile ? 'mb-5' : 'mt-5 mb-5'} style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Certificação ABEA</h1>

                    <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                        O objetivo da certificação é credenciar empresas de insumos que estejam alinhadas aos propósitos do nosso programa, promovendo, aumentando e/ou garantindo o bem-estar animal por meio dos seus produtos e/ou serviços.<br /><br />
                        O mercado tem pedido cada vez mais por produtos que venham de origem que respeite o bem-estar dos animais, do início ao fim do processo de produção. Afinal, esse é o caminho mais sustentável. E as empresas que auxiliam toda a cadeia produtiva são essenciais para que cada vez mais tenhamos produtos com selo de Bem-estar Animal. Por isso, conte com a Certificação para Empresa Amiga do Bem-estar Animal.<br /><br />
                        Quem se certifica aumenta possibilidades de negócio com fazendas, granjas e laticínios, além de estar mais próximo das necessidades do mercado, antevendo o que acontecerá no futuro.
                    </span>

                </div>
            </div>
        </>
    );
}

export default Sobre;
